/* unplugin-vue-components disabled */import { render } from "./language-selector.vue?vue&type=template&id=105b5b82"
import script from "./language-selector.vue?vue&type=script&lang=js"
export * from "./language-selector.vue?vue&type=script&lang=js"

import "./language-selector.vue?vue&type=style&index=0&id=105b5b82&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__